import React from 'react';
import { useTranslation } from 'react-i18next';
import { VerdictType } from '../core/types';

interface Props {
  disabled: boolean;
  onVerdict: (verdict: VerdictType) => void;
}

const VERDICTS: { type: VerdictType; labelKey: string; className: string }[] = [
  { type: 'approve',     labelKey: 'decision.approve',     className: 'approve-btn' },
  { type: 'reject',      labelKey: 'decision.reject',      className: 'reject-btn' },
  { type: 'defer',       labelKey: 'decision.defer',       className: 'defer-btn' },
  { type: 'noid',        labelKey: 'decision.noid',        className: 'noid-btn' },
  { type: 'referral',    labelKey: 'decision.referral',    className: 'referral-btn' },
  { type: 'supervisor',  labelKey: 'decision.supervisor',  className: 'supervisor-btn' },
  { type: 'reinterview', labelKey: 'decision.reinterview', className: 'reinterview-btn' },
];

const DecisionPanel: React.FC<Props> = ({ disabled, onVerdict }) => {
  const { t } = useTranslation();
  return (
    <div className="decision-panel">
      <h2>{t('decision.prompt')}</h2>
      <div className="decision-buttons">
        {VERDICTS.map(({ type, labelKey, className }) => (
          <button
            key={type}
            className={className}
            onClick={() => onVerdict(type)}
            disabled={disabled}
          >
            {t(labelKey)}
          </button>
        ))}
      </div>
    </div>
  );
};

export default DecisionPanel;
